import { observable, action } from "mobx"
import api from "../services/ApiDefault"
import { showResponseError } from "../utilities/utils"

export class CommissionStore {
  @observable isLoading = false
  @observable commissions = []
  @observable params = { page: 1, perPage: 20, total: 0, lastPage: 1 }
  @observable summary = null

  @action
  async getCommissions(params = {}) {
    this.isLoading = true
    this.params = { ...this.params, ...params }
    const response = await api.getCommissions(this.params)
    if (response.ok) {
      const { data, page, perPage, total, lastPage } = response.data.data
      this.commissions = data
      this.params = { ...this.params, page, perPage, total, lastPage }
    } else {
      showResponseError(response)
    }
    this.isLoading = false
  }

  @action
  async getSummary(params = {}) {
    const response = await api.getCommissionsSummary(params)
    if (response.ok) {
      this.summary = response.data.data
    } else {
      showResponseError(response)
    }
  }
}

const commissionStore = new CommissionStore()
export default commissionStore
